<template>
    <div class="admin-useragreement">
        <h1 class="admin-useragreement-title">机动车综合服务平台服务协议</h1>
        <p class="admin-useragreement-preface">
            《机动车综合服务平台服务协议》，是本公司（以下简称“我方”）和营销顾问（以下称“您”或“贵方”）所约定的规范双方权利和义务的具有法律效力的电子协议，下称“本协议”。贵方完整、认真的阅读本文或已与我方建立合作关系，即表示贵方已经完全地毫无保留地接受本协议的所有条款。
        </p>
        <div class="admin-useragreement-content">
            <div class="admin-useragreement-content-item">
                <h3>第一条 总则</h3>
                <p>
                    1、贵方根据我方注册要求及规则，在我方合法经营的机动车综合服务平台（以下简称“平台”）上申请成为我方营销顾问，在我方平台从事营销宣传活动，即使用我方平台提供的服务从事包括但不限于市场营销策划、产品展示设计、产品推广服务、技术咨询、技术服务等活动（以下简称“市场营销”），贵方在我方平台进行市场营销期间均应视为协议期内。
                </p>
                <p>
                    2、签署本协议前，贵方已充分了解我方之各项规则及要求，且有条件及有能力、资格履行本协议约定的营销职责及义务。本协议对贵方构成有效的、带有约束力的、可强制执行的法定义务，贵方对本协议下所有条款及定义等内容均已明确知悉，并无疑义。
                </p>
                <p>
                    3、贵方承诺并声明在我方平台进行市场营销时符合所在地法律的相关规定，不得以履行本协议名义从事其他违反中国及所在地法律规定的行为。
                </p>
                <p>
                    4、贵方与我方不构成任何法律层面的雇佣、劳动、劳务关系，我方无需向贵方承担任何社会保险金和福利。
                </p>
                <p>
                    5、市场营销费用：平台营销顾问开展市场营销活动，我方将根据成效和业绩给予奖励。
                </p>
            </div>

            <div class="admin-useragreement-content-item">
                <h3>第二条 我方权利义务</h3>
                <p>
                    1、贵方同意我方制定平台运营制度及对市场营销活动的管理规则，对贵方进行规范和监督，根据运营情况对相应规则做出调整或变更， 对贵方进行考察、评判，以确立（取消）对贵方的奖励机制。
                </p>
                <p>
                    2、平台的解释权由我方所有，贵方完成注册申请且经我方审核通过后，获得平台内容使用权。注册号仅限于您本人使用，禁止赠与、转让、出借、出租或售卖。、我方对贵方进行的市场营销相关事宜拥有最终决定权。
                </p>
                <p>
                    3、我方有权使用贵方的名称（包括但不限于贵方真实姓名、笔名、网名、曾用名及任何代表贵方身份的文字符号）、肖像（包括但不限于真人肖像及卡通肖像等）进行我方平台的各类宣传。
                </p>
                <p>
                    4、我方负责提供平台技术服务支持，同时负责平台市场营销奖励（若有）结算。
                </p>
            </div>

            <div class="admin-useragreement-content-item">
                <h3>第三条 贵方权利义务</h3>
                <p>
                    1、贵方须年满18周岁，贵方保证不会因执行本协议损害任何第三方合法利益和导致我方对任何第三方承担责任。
                </p>
                <p>
                    2、贵方在市场营销过程中，不得使用欺诈、胁迫及其他非正常手段（包括盗号、转卖号、系统bug、平台发放错误、过度承诺客户等，具体以我方解释为准）从事营销活动，导致我方或任何第三方遭受任何损害的，贵方应独立承担责任，对于非正常手段获得的营销服务费用，我方有权进行独立判断和处理，我方因此遭受损失的，贵方应当一并赔偿。
                </p>
                <p>
                    3、贵方如在市场营销过程中做出任何超出我方允许的承诺，与我方无关，贵方应当自行解决并独立承担全部法律责任，如我方因此遭受任何名誉或经济损失的，贵方应予以赔偿并负责消除给我方造成的不良影响。
                </p>
                <p>
                    4、贵方承诺注册必须用作本协议约定的市场营销或我方根据平台发展需要而增加的其他业务用途，不得用于其他任何非我方允许的活动（包括但不限于不得提供与我方无关的广告、推介等服务，或从事任何违法行为）。
                </p>
                <p>
                    5、贵方所获得的营销服务费用应当依据国家相关法律法规缴纳税金，我方将贵方所获得的营销服务费用支付于贵方在用户中心中填写的银行账户中，贵方可在登陆我方平台后在个人中心中查询相关信息（结算数据为含税数据）。
                </p>
                <p>
                    6、贵方平台注册并通过个人认证的，则我方有权将贵方所获得的服务费用支付于贵方在用户中心填写的个人银行账户或贵方填写的微信、支付宝等账户中。
                </p>
                <p>
                    7、贵方保证填写账户信息正确、真实、有效，如因账户信息造成我方的任何支付错误，由贵方独自承担责任。同时，若贵方需要变更账户信息，需及时书面通知我方，新账户信息由贵方提交申请且经我方审核通过后下一个结算月生效。
                </p>
            </div>

            <div class="admin-useragreement-content-item">
                <h3>第四条 保密制度</h3>
                <p>
                    1、贵方应严格遵守我方的保密制度，承诺无限期保守我方的商业秘密。因贵方违反约定使用或披露我方商业秘密和信息使我方及/或我方平台遭受任何名誉、声誉或经济上的、直接或间接的损失，贵方应赔偿我方人民币【100000】元违约金，不足以弥补我方损失的，贵方还应赔偿我方损失。 商业秘密是指由我方提供的、或者贵方在双方合作期间了解到的、或者我方对第三方承担保密义务的，与我方业务有关的，能为我方带来经济利益，具有实用性的、非公知的所有信息，包括（但不限于）：技术信息、经营信息和与我方行政管理有关的信息和文件（含本协议及相关协议内容）、贵方从我方获得的奖励金额和结算方式、标准、权利归属方式、授权方式、客户名单、其他团队长名单、联系方式、奖励费用、我方工作人员名单及联系方式等不为公众所知悉的信息。
                </p>
                <p>
                    2、贵方应严格遵守本协议，未经我方书面授权或同意，对我方的商业秘密不得：<br />
                    （1）以任何方式向第三方或不特定的公众进行传播、泄露；<br />
                    （2）为非本协议的目的而使用我方的商业秘密。<br />
                </p>
                <p>
                    3、本协议终止后，贵方应将我方商业秘密悉数返还我方，或在我方监督下，将记载我方商业秘密的全部文件销毁。本条规定在本协议终止后仍然有效。
                </p>
            </div>

            <div class="admin-useragreement-content-item">
                <h3>第五条 协议的变更、解除、终止</h3>
                <p>
                    1、本协议内容同时包括本协议以及我方可能不时发布的其他相关协议、规则、声明、政策等内容。上述内容一经正式发布，即成为本协议不可分割的组成部分，贵方同样应当遵守。我方有权在必要时单方变更、终止、中止本协议或上述内容，并在相关页面进行通知，变更后的协议或相关内容一旦在相关的页面上公布即有效代替原来的协议或内容。本协议条款或相关内容变更后，如贵方继续在我方平台进行市场营销，即视为贵方已知悉并接受变更后的协议和相关内容。如贵方不同意我方对本协议或相关内容所作的任何变更，贵方应立即书面通知我方并停止在我方平台进行的任何市场营销活动。
                </p>
                <p>
                    2、双方就解除本协议协商一致即可终止协议。
                </p>
                <p>
                    3、贵方有下列情形之一，我方可以立即解除本协议，不需要提前通知：<br />
                    （1）我方发现贵方违反对本协议所做的声明与承诺的；<br />
                    （2）因贵方个人行为直接或间接给对我方利益造成重大损害的；<br />
                    （3）违反国家法律法规的；<br />
                    （4）违反本协议规定的其它义务；<br />
                    （5）以消极、不作为等不符合我方要求的方式履行本协议的（即使未构成违约），经我方通知后【10】日内仍未改正的；<br />
                    （6）因异常情形的出现，我方认为贵方不适合进行本协议下市场营销活动，经我方通知后【10】日内异常情形仍未消除的；<br />
                    （7）因我方业务调整，决定停止本协议所涉及的业务。<br />
                </p>
            </div>

            <div class="admin-useragreement-content-item">
                <h3>第六条 违约责任</h3>
                <p>
                    1、任何由于贵方声明不实或违反其声明承诺事项导致他方向我方提起诉讼、索赔及/或导致我方声誉受损之后果，贵方将承担我方因此产生的全部直接及间接费用、损失及赔偿，其中包括我方为诉讼支付的有关费用及律师费。
                </p>
                <p>
                    2、除本协议另有约定外，贵方违反本协议下任何规定的，我方有权视情形，采取包括但不限于下列任一种或多种措施追究贵方的违约责任：<br />
                    （1）暂时地封停贵方的注册账号，直至贵方纠正其违约行为；<br />
                    （2）永久性地封停贵方的注册账号；<br />
                    （3）永久性地删除贵方的注册账号；<br />
                    （4）拒绝贵方再次注册我方平台的账号；<br />
                    （5）暂时地中止向贵方结算和支付奖励，直至贵方纠正其违约行为；<br />
                    （6）将尚未支付给贵方的奖励以及贵方在平台上的账户余额作为贵方支付给我方的违约金，不再支付给贵方； 如果上述违约金金额仍不足以补偿我方损失的，贵方还应补充赔偿；<br />
                    （7）要求贵方返还我方已支付的全部或部分奖励费用；<br />
                    （8）我方自行或委托第三方先行向他方支付相关费用，再从贵方的奖励费用中等额扣除，不足部分贵方应予以补足；<br />
                    （9）我方因此遭受任何经济、名誉上损失，贵方应予以全额赔偿并负责消除给我方造成的不良影响。<br />
                </p>
                <p>
                    3、若贵方提供的市场营销服务不符合我方的要求，我方有权不予支付相关奖励。
                </p>
            </div>

            <div class="admin-useragreement-content-item">
                <h3>第七条 免责声明</h3>
                <p>
                    1、我方不担保网络服务一定能满足贵方的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也都不作担保。
                </p>
                <p>
                    2、我方不保证为贵方提供便利而设置的外部链接的真实性、准确性和完整性，同时，对于该等外部链接指向的不由我方实际控制的任何网页上的内容，我方不承担任何责任。
                </p>
                <p>
                    3、 对于因电信系统或互联网网络故障、计算机故障或病毒、信息损坏或丢失、计算机系统问题或其它任何不可抗力原因而产生损失，我方不承担任何责任，但将尽力减少因此而给贵方造成的损失和影响。
                </p>
            </div>

            <div class="admin-useragreement-content-item">
                <h3>第八条 法律适用及争议处理</h3>
                <p>
                    1、本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国法律（不包括冲突法）。
                </p>
                <p>
                    2、因履行本协议而产生的任何争议，双方均应本着友好协商的原则加以解决。协商解决未果，任何一方均可以提请本协议签订地芜湖市镜湖区人民法院诉讼解决。
                </p>
            </div>

            <div class="admin-useragreement-content-item">
                <h3>第九条 其他</h3>
                <p>
                    1、本协议未尽事宜，或与国家、地方有关规定相悖的，按有关规定执行。
                </p>
                <p>
                    2、本协议签订地：芜湖市镜湖区 本协议共九条，本行以下无协议正文。
                </p>
            </div>
        </div>
        <div class="admin-useragreement-specials">
            <h5>*特别声明</h5>
            <p>
                鉴于我国《合同法》第39条规定：采用格式条款订立合同的，提供格式条款的一方应当遵循公平原则确定当事人之间的权利和义务，并采取合理的方式提请对方注意免除或者限制其责任的条款，按照对方的要求，对该条款予以说明。 我方在此依法做出特别声明如下：
            </p>
            <p>
                法定的我方采取合理的方式提请贵方注意的义务将通过如下方式实现：在本协议中我方以明确的足以引起贵方注意的加重字体、斜体、下划线、颜色标记等合理方式提醒贵方注意相关条款（需要强调的是，还包括贵方应特别注意任何未明确标记的含有“不承担”、“免责”“不得”等形式用语的条款），该等条款的确认将导致贵方在特定情况下的被动、不便、损失，包括但不限于本合同第一条、第三条、第四条、第五条、第六条、第七条等，请贵方在确认同意本协议之前再次阅读上述条款。双方确认上述条款非属于《合同法》第40条规定的“免除其责任、加重对方责任、排除对方主要权利的”的条款，我方尊重贵方的权利尤其是诉讼的权利，但作为全国性公司，我方在尊重贵方诉讼权利的同时建议诉讼管辖地法院为芜湖市镜湖区法院，而贵方选择同意合同并进行市场营销即视为双方对此约定达成了一致意见。
            </p>
            <p>
                法定的我方向贵方说明这些条款的义务将通过如下方式实现：而贵方如有任何需要说明条款的要求，请立即停止注册使用，同时立即致电书面通知我方，若贵方未致电或发送有说明条款要求的邮件至我方而选择同意该协议，则双方在此确认我方已依法履行了根据贵方要求对相关条款进行说明的法定义务，我方已给予贵方充足的时间与充分的选择权来决定是否缔结本协议。
            </p>
            <p>
                鉴于我方已依法明确了上述条款、履行了格式条款制订方的义务，贵方点击同意或下一步，将被视为且应当被视为贵方已经完全注意并同意了本协议所有条款尤其是提醒贵方注意的条款的合法性及有效性，贵方不应当以我方未对格式条款以合理方式提醒贵方注意或未根据贵方要求尽到说明义务为理由而声称或要求法院或其它任何第三方确认相关条款非法或无效。
            </p>
        </div>
        <div class="admin-useragreement-footer">
            <span>版本设立日期： 2018年05月14日</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Agreement',

    data() {
        return {};
    },

    methods: {}
};
</script>
<style lang="scss">
.admin-useragreement {
    box-shadow: 0 1px 2px 0 rgba(161, 171, 181, 0.48),
        0 2px 4px 0 rgba(213, 222, 231, 0.64) !important;
    border: 0 none !important;
    background-color: #fff;
    margin: 15px;
    padding: 25px;
    font-size: 14px;
}
.admin-useragreement-title {
    line-height: 60px;
    font-size: 24px;
    color: #000;
    text-align: center;
}
.admin-useragreement-preface {
    padding: 15px 0;
}
.admin-useragreement-content {
    .admin-useragreement-content-item {
        h3 {
            color: #000;
            font-weight: bold;
            padding: 25px 0 5px 0;
        }
        p {
            padding: 5px 0;
        }
    }
}
.admin-useragreement-specials {
    padding: 25px 0 0 0;
    color: #000;
    font-weight: bold;
    h5 {
        padding: 0 0 25px 0;
        font-size: 14px;
        font-weight: bold;
    }
    p {
        padding: 0 0 25px 0;
    }
}
.admin-useragreement-footer {
    height: 50px;
    span {
        height: 50px;
        line-height: 50px;
        float: right;
    }
}
</style>